export default __webpack_public_path__ + "static/iliad-epic-grow-header-video-2419c1acc6473d07c3a88cd0b47afcfe.webm";